import { __awaiter, __rest } from "tslib";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FORM_ERROR } from 'final-form';
import CreateAccount from '../CreateAccount';
import AgreementCheckboxWrapper from '../../../../../../AgreementCheckboxWrapper';
import Link from '../../../../../../Link';
import { useConfig } from '../../../../../../context';
import { useTheme } from '../../../../../../theme';
const CreateAccountWithCheckbox = (_a) => {
    var _b;
    var { checkboxes: initialCheckboxes } = _a, props = __rest(_a, ["checkboxes"]);
    const { t } = useTranslation('Account');
    const theme = useTheme('Loyalty').LoyaltyConnect;
    const companyInfo = (_b = useConfig()) === null || _b === void 0 ? void 0 : _b.global.companyInfo;
    const [showTooltip, setShowTooltip] = useState(false);
    const checkboxes = React.useMemo(() => {
        if ((initialCheckboxes === null || initialCheckboxes === void 0 ? void 0 : initialCheckboxes.length) > 0) {
            return initialCheckboxes;
        }
        const links = [];
        const exarePrivacyPolicyURL = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.exarePrivacyPolicyURL;
        const loyaltyProgramRulesUrl = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.loyaltyProgramRulesUrl;
        if (exarePrivacyPolicyURL) {
            links.push(React.createElement(Link, { target: '_blank', action: exarePrivacyPolicyURL }, t('CreateAccountCheckbox_exarePrivacyPolicy')));
        }
        if (loyaltyProgramRulesUrl) {
            links.push(React.createElement(Link, { target: '_blank', action: loyaltyProgramRulesUrl }, t('CreateAccountCheckbox_loyaltyStatus')));
        }
        if (links.length === 0) {
            return [];
        }
        return [
            {
                tooltipTitle: t('CreateAccountCheckbox_tooltipTitle'),
                fieldName: 'policy',
                label: (React.createElement(React.Fragment, null,
                    React.createElement("span", null,
                        t('CreateAccountCheckbox_agreeWith'),
                        " ",
                        links[0]),
                    !!links[1] && (React.createElement("span", null,
                        ` ${t('CreateAccountCheckbox_and')} `,
                        " ",
                        links[1])))),
                required: true
            }
        ];
    }, [companyInfo, initialCheckboxes, t]);
    const handleSubmitButtonClick = (isValid) => {
        setShowTooltip(false);
        if (!isValid) {
            setShowTooltip(true);
        }
    };
    const handleCreateAccount = (params, isValid, invalidCallback) => __awaiter(void 0, void 0, void 0, function* () {
        if (!isValid) {
            invalidCallback === null || invalidCallback === void 0 ? void 0 : invalidCallback();
            return { [FORM_ERROR]: '' };
        }
        return props.onCreateAccount(params);
    });
    if (checkboxes.length === 0) {
        return React.createElement(CreateAccount, Object.assign({}, props));
    }
    return (React.createElement(AgreementCheckboxWrapper, { className: theme.agreementCheckboxWrapper, showTooltip: showTooltip, checkboxes: checkboxes }, ({ isValid, scrollToCheckboxes }) => (React.createElement(CreateAccount, Object.assign({}, props, { onSubmitForm: () => handleSubmitButtonClick(isValid), onCreateAccount: params => handleCreateAccount(params, isValid, scrollToCheckboxes) })))));
};
export default CreateAccountWithCheckbox;
